import { topics } from "@/mocks/content";

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function MoreSection() {
  return (
    <section id="more" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="max-w-2xl" data-reveal>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            延伸浏览：由剧情延伸出的六个话题
          </h2>
          <p className="mt-3 text-foreground-600 leading-8">
            好的故事常常会把人带回自己的生活。下面这些话题与年轻母亲题材直接相关，
            可以作为看完一部剧之后继续想一想的线索。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((t) => (
            <div
              key={t.title}
              data-reveal
              className="p-5 rounded-xl bg-background-100 border border-background-200 hover:border-accent-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${t.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-foreground-950 text-base">
                {t.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-7">{t.text}</p>
            </div>
          ))}
        </div>

        <div
          className="mt-12 rounded-2xl bg-primary-500 text-background-50 px-6 py-10 md:px-12 md:py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6"
          data-reveal
        >
          <div className="max-w-xl">
            <h3 className="font-heading font-semibold text-xl md:text-2xl">
              回到题材选片，挑一个适合现在的方向
            </h3>
            <p className="mt-3 text-sm text-background-100/90 leading-7">
              无论你想找一部慢慢看的短剧，还是想先弄懂剧情结构，
              都可以从题材标签开始，用几分钟找到值得关注的内容。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button
              type="button"
              onClick={() => scrollToId("catalog")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-layout-grid-line text-lg" aria-hidden="true"></i>
              查看题材选片
            </button>
            <button
              type="button"
              onClick={() => scrollToId("top")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/60 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
              回到顶部
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}